import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";
import { googleAuthCallback, adAuthCallback } from "~/routes";

const commonSettings: Partial<UserManagerSettings> = {
  scope: "openid profile email",
  response_type: "code",
  automaticSilentRenew: false,
  userStore: new WebStorageStateStore({ store: localStorage }),
};

export function getGoogleSettings(): UserManagerSettings {
  const redirectUri = `${window.location.origin}${googleAuthCallback.path}`;
  return {
    ...commonSettings,
    authority: "https://accounts.google.com",
    client_id: window.config.googleAuthClientId,
    client_secret: window.config.googleAuthClientSecret,
    redirect_uri: redirectUri,
    silent_redirect_uri: redirectUri,
  };
}

export function getAzureAdSettings(): UserManagerSettings {
  const { azureAdAuthClientId, azureAdAuthTenantId } = window.config;
  const redirectUri = `${window.location.origin}${adAuthCallback.path}`;
  return {
    ...commonSettings,
    authority: `https://login.microsoftonline.com/${azureAdAuthTenantId}/v2.0`,
    client_id: azureAdAuthClientId,
    redirect_uri: redirectUri,
    silent_redirect_uri: redirectUri,
  };
}
